import { render, staticRenderFns } from "./HBanner.vue?vue&type=template&id=2f3aaeac&scoped=true&"
import script from "./HBanner.vue?vue&type=script&lang=js&"
export * from "./HBanner.vue?vue&type=script&lang=js&"
import style0 from "./HBanner.vue?vue&type=style&index=0&id=2f3aaeac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3aaeac",
  null
  
)

export default component.exports